import { Link } from 'react-router-dom';
import FadeInSection from '../../../components/feature/FadeInSection';

export default function MessageSection() {
  return (
    <section className="section-padding" style={{ background: '#fff8f2' }}>
      <div className="content-width">
        <FadeInSection className="max-w-[760px] mx-auto text-center">
          <div
            className="mb-6 mx-auto flex items-center justify-center w-16 h-16 rounded-full"
            style={{ background: '#e8934e' }}
          >
            <i className="ri-heart-2-line text-white text-2xl"></i>
          </div>
          <h2 style={{ color: '#8b4513' }} className="mb-8">
            「和はは」からのメッセージ
          </h2>
          <p style={{ color: '#4a3728', lineHeight: '2', fontSize: 'clamp(14px, 2vw, 18px)' }}>
            人生100年時代を迎え、私たちのライフスタイルは大きく変わりました。
            特に、大人世代にとっての課題のひとつが「孤独」です。
          </p>
          <p style={{ color: '#4a3728', lineHeight: '2', fontSize: 'clamp(14px, 2vw, 18px)' }} className="mt-5 md:mt-6">
            和ははが目指すのは、単なる「結婚相談所」ではなく、
            大人世代が安心してつながれる場をつくること。
            「ひとりじゃない」と思えるだけで、世界はもっと明るくなる。
          </p>
          <p style={{ color: '#8b4513', fontWeight: '700', fontSize: 'clamp(15px, 2.5vw, 20px)', lineHeight: '2' }} className="mt-5 md:mt-6">
            「和はは」は、そんな未来を応援していきます。
          </p>

          <div
            className="mt-10 mx-auto"
            style={{
              height: '3px',
              background: 'linear-gradient(to right, #e8934e, #5a9e6f)',
              borderRadius: '2px',
              maxWidth: '120px',
            }}
          />

          <div className="mt-8">
            <Link
              to="/greeting"
              style={{
                color: '#8b4513',
                fontSize: '15px',
                fontWeight: '600',
                borderBottom: '1px solid #d4a574',
                paddingBottom: '2px',
              }}
              className="hover:opacity-70 transition-opacity whitespace-nowrap inline-flex items-center gap-1"
            >
              代表からのご挨拶を読む
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
